import { memo, PropsWithChildren } from 'react';

interface Props {
  imgClassName?: string;
}

const GradientBg = ({ imgClassName, children }: PropsWithChildren<Props>) => {
  const className = imgClassName || 'w-[180%] max-w-[180%] z-0 left-[-40%] right-[40%] top-[-80%]';

  return (
    <div className="relative overflow-visible">
      <img
        src="/images/umo-nm-gradient-bg.png"
        alt=""
        aria-hidden="true"
        className={`${className} absolute pointer-events-none blur-xs`}
      />

      <div className="relative z-1">{children}</div>
    </div>
  );
};

export default memo(GradientBg);
